/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import clsx from 'clsx'
import { useEffect, useMemo, useRef, useState, type FunctionComponent } from 'react'
import useWindowDimensions from '../../../hooks/useWindowDimensions'
import { ellipsedText } from '../../const/EllipsedTextHelper'
import { INTRO_ROWS_HEIGHT, INTRO_ROWS_HEIGHT_MOBILE } from '../../const/digitContants'
import type { ContentBlockResult } from '../../data/ContentFragment'
import { Content } from '../content/Content'
import { Container } from './Container'
import style from './Intro.module.sass'
import { ShowMoreLessButton } from './ShowMoreLessButton'

type IntroProps = {
	title: string | JSX.Element
	subtitle?: string
	lead?: ContentBlockResult[]
	leftAligned?: boolean
	withAd?: boolean
	isCentered?: boolean
}

export const Intro: FunctionComponent<IntroProps> = ({
	title,
	subtitle,
	leftAligned = false,
	withAd = false,
	lead,
	isCentered = false,
}) => {
	const [isTextComplete, setIsTextComplete] = useState(false)
	const [height, setHeight] = useState(0)
	const [textIsLonger, setTextIsLonger] = useState(false)

	const { width } = useWindowDimensions()

	const extraLongSubtitle = subtitle && subtitle.length > 290
	const lastCharacterVisible = 260

	const threeRowsHeight = width && width > 768 ? INTRO_ROWS_HEIGHT : INTRO_ROWS_HEIGHT_MOBILE

	const isLongCheck = height > threeRowsHeight - 20 // 1 row

	const ellipsedSubtitle = useMemo(() => {
		if (extraLongSubtitle) {
			const shortenedText = ellipsedText(subtitle, lastCharacterVisible)
			return shortenedText
		}
		return subtitle
	}, [extraLongSubtitle, subtitle])

	const ref = useRef<HTMLDivElement>(null)

	useEffect(() => {
		setHeight(Number(ref.current?.clientHeight))
		if (height > threeRowsHeight) {
			setTextIsLonger(true)
		}
	}, [height, threeRowsHeight])

	return (
		<>
			<h1 className={clsx(style.title, leftAligned && style.titleLeft, withAd && style.titleNoMarginLeft)}>{title}</h1>
			<div className={clsx(style.wrapper, !leftAligned && !withAd && style.wrapperMargin)} id="anchorIntro">
				<Container size="narrow" disableGutters>
					{lead && lead.length > 0 ? (
						<div
							ref={ref}
							style={{
								height: textIsLonger ? threeRowsHeight : 'auto',
								zIndex: -1,
								overflow: 'hidden',
							}}
						>
							<Content blocks={lead} />
						</div>
					) : (
						<p className={clsx(style.subtitle, withAd && style.subtitleWithAd, isCentered && style.subtitleIsCentered)}>
							{isTextComplete && extraLongSubtitle ? subtitle : ellipsedSubtitle}
						</p>
					)}
					{extraLongSubtitle && (
						<div className={style.buttonWrapper}>
							<ShowMoreLessButton
								anchorId="anchorIntro"
								moreIsVisible={!isTextComplete}
								onClick={() => setIsTextComplete(!isTextComplete)}
							/>
						</div>
					)}
					{lead && isLongCheck && (
						<div className={style.buttonWrapper}>
							<ShowMoreLessButton
								anchorId="anchorIntro"
								moreIsVisible={textIsLonger}
								onClick={() => setTextIsLonger(!textIsLonger)}
							/>
						</div>
					)}
				</Container>
			</div>
		</>
	)
}
